import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as tagsConstants from '../constants/tags'
import { getTags, createTag, updateTag } from '../actions/tags'
import { logOutToken } from '../actions/token'
import { getUsers } from '../actions/user'
import { createEmailRecipient, updateEmailRecipient } from '../actions/email_recipients'

//CSS
import '../App.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'semantic-ui-css/semantic.min.css';
import 'react-datepicker/dist/react-datepicker.css';

//UI libraries
import { Icon, Image } from 'semantic-ui-react'
import TrainingMatrixModal from './components/modals/training_matrix_modal'
import LogoutMessage from './components/modals/logout_message'
import TagDashboard from './tag_dashboard'
import TagMatrix from './tag_matrix'
import SystemHeader from './components/system_header'
import Trainees from './v2_trainees'
import CountryComparison from './country_comparison'
import V2TrainingModules from './v2_training_modules'
import EmailRecipientModal from './components/modals/email_recipient_modal'
import TrainingNeedsAnalysis from './training_needs_analysis';
import ObjectITButton from './components/developed_by_objectit/objectit_button';

class TrainingRegister extends Component {
  constructor(props){
    super(props);

    this.state = {
      trainingMatrices: [],
      showMatrixModal: false,
      showMatricesList: true,
      showLogOutMessage: false,
      showMatrix: false,
      showDashboard: false,
      sidebarShown: false,
      openAfterCreate: false,
      tagId: null,
      matrixName: null,
      activeItem: {},
      showTrainees: false,
      showCountryComparison: false,
      showTrainingModules: false,
      showEmailRecipientModal: false,
      showTrainingNeedsAnalysis: false
    }

    this.activeItemRef = null;
    this.deleteId = null;
    this.origTitle = '';
    this.tagName = ''
    this.tagsRequestParams = {
      manager_id: props.user.id,
      context: 'regions'
    }

    this.toggleSideBar = this.toggleSideBar.bind(this)
    this.onTitleBlur = this.onTitleBlur.bind(this)
    this.onTitleFocus = this.onTitleFocus.bind(this)
  }

  // FUNCTIONS FOR DATA MANIPULATION
  componentDidMount() {
    this.props.getTags(this.tagsRequestParams)
  }

  componentWillReceiveProps(nextProps){
    this.handleUsersNextProps(nextProps)
    this.handleTagsNextProps(nextProps)
    this.handleEmailRecipientsNextProps(nextProps)
  }

  handleUsersNextProps = (nextProps) => {
    if(this.currentView !== 'TrainingRegister') return
    if(nextProps.usersRequestType===this.props.usersRequestType) return 
    if (nextProps.usersRequestType==='GET_USERS_SUCCESS'){
      this.setState({
        users: nextProps.users,
        user: nextProps.user,
        showEmailRecipientModal: true
      })
    }
  }

  handleTagsNextProps = (nextProps) => {
    if(this.props.tagsRequestType === nextProps.tagsRequestType) return;

    if(nextProps.tagsRequestSuccess) {
      switch (nextProps.tagsRequestType){
        case tagsConstants.GET_TAGS_SUCCESS:
          if (this.tagsRequestParams.context === 'regions') this.setTrainingMatrices(nextProps)
          break
        case tagsConstants.UPDATE_TAG_SUCCESS:
          if (this.state.showTrainees || this.state.showTrainingModules) return;
          this.props.getTags(this.tagsRequestParams)
          break
        case tagsConstants.CREATE_TAG_SUCCESS:
          if (this.state.showTrainees || this.state.showTrainingModules) return;
          this.setState({
            openAfterCreate: true,
            showMatrix: false,
            showDashboard: false
          })
          this.props.getTags(this.tagsRequestParams)
          break
        default:
          break
      }
    }
  }

  handleEmailRecipientsNextProps = (nextProps) => {
    if(this.props.emailRecipients.requestType===nextProps.emailRecipients.requestType) return
    var {requestType, emailRecipient} = nextProps.emailRecipients
    if(['CREATE_EMAIL_RECIPIENT_SUCCESS', 'UPDATE_EMAIL_RECIPIENT_SUCCESS'].includes(requestType)){
      this.setState({emailRecipient})
      this.props.getTags(this.tagsRequestParams)
    }
  }

  toggleSideBar(evt) {
    this.setState({ sidebarShown: !this.state.sidebarShown })
    this.refs['menu'].classList.toggle('show-menu');
    this.refs['menu'].classList.toggle('hide-menu');
    this.refs['content'].classList.toggle('extend-training-matrices-content')
  }

  hideSideBar() {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  createMenuItems() {
    var items = []
    items = items.concat(
      <a ref='trainees' className={this.activeItemRef === 'trainees' ? 'item active-item' : 'item'} key={ 'trainees' } onClick={() => this.openTrainees() }>
        <span><Icon name='users' /> All Trainees</span>
      </a>
    )
    items = items.concat(
      <a ref='training modules' className={this.activeItemRef === 'training modules' ? 'item active-item' : 'item'} key={ 'training modules' } onClick={() => this.openTrainingModules() }>
        <span><Icon name='book' /> Training Modules</span>
      </a>
    )
    items = items.concat(
      <a ref='tna' className={this.activeItemRef === 'tna' ? 'item active-item' : 'item'} key={ 'tna' } onClick={() => this.openTrainingNeedsAnalysis() }>
        <span><Icon name='book' /> Training Needs Analysis</span>
      </a>
    )
    items = items.concat(
      <a ref='dashboards' className={this.activeItemRef === 'dashboards' ? 'item active-item' : 'item'} key={ 'dashboards' } onClick={() => this.openDashboards() }>
        <span><Icon name='area graph' /> Country Comparison</span>
      </a>
    )
    items = items.concat(
      <a className="item" key={ 'training_matrices' } onClick={ () => this.setState({ showMatricesList: !this.state.showMatricesList }) }>
        <span><Icon name='list' /> Training Matrices</span>
        { (!this.state.showMatricesList) && <Icon name='chevron right'/> }
        { (this.state.showMatricesList) && <Icon name='chevron down'/> }
      </a>
    )
    if (this.state.showMatricesList) {
      if(Array.isArray(this.state.trainingMatrices)) {
        items = items.concat(this.createMatricesItems())
      }
    }
    if (this.props.user.is_admin) {
      items = items.concat(
        <a className="item" key={ 'create_new_matrix' } onClick={this.toggleMatrixModal}>
          <span><Icon name='plus' /> Create New Matrix</span>
        </a>
      )
    }
    items = items.concat(
      <a className="item" key={ 'log_out' } onClick={() => this.props.logout(this.props.token) }>
        <span><Icon name='log out' /> Logout</span>
      </a>
    )
    items = items.concat(
      <span>
        <ObjectITButton />
      </span>
    )
    return items
  }

  createMatricesItems(){
    return this.state.trainingMatrices.map((matrix) => {
      var items = [];
      var regionId = `region_${matrix.id}`;
      var state = {};
      var key0 = matrix.id + '_0';
      var key1 = matrix.id + '_1';
      var key2 = matrix.id + '_2';
      var key3 = matrix.id + '_3';
      var key4 = matrix.id + '_4';

      state[regionId] = !this.state[regionId];
      items = items.concat(
        <a className='item matrices-list' key={ key0 } onClick={ ()=> this.setState(state) }>
          <span><Icon name='file alternate'/> { matrix.name }</span>
          { (!this.state[regionId]) && <Icon name='chevron right'/> }
          { (this.state[regionId]) && <Icon name='chevron down'/> }
        </a>
      )
      if (this.state[regionId]) {
        items = items.concat(
          <a
            ref={ key1 }
            className={ this.activeItemRef === key1 ? 'item matrix-options active-item' : 'item matrix-options' }
            key={ key1 }
            onClick={ ()=> { this.openMatrix(matrix.id, matrix.name); this.setActiveItem(key1) } }
          >
            <span><Icon name='book'/> Matrix</span>
          </a>
        )
        items = items.concat(
          <a
            ref={ key2 }
            className={ this.activeItemRef === key2 ? 'item matrix-options active-item' : 'item matrix-options' }
            key={ key2 }
            onClick={ ()=> { this.openDashboard({id: matrix.id, item: 0}, matrix.name); this.setActiveItem(key2) } }>
            <span><Icon name='user'/>Training Dashboard</span>
          </a>
        )
        items = items.concat(
          <a
            ref={ key3 }
            className={ this.activeItemRef === key3 ? 'item matrix-options active-item' : 'item matrix-options' }
            key={ key3 }
            onClick={ ()=> { this.openDashboard({id: matrix.id, item: 1}, matrix.name); this.setActiveItem(key3) } }>
            <span><Icon name='file excel'/> <span>Personnel Training Dashboard</span></span>
          </a>
        )
        if (this.props.user.is_admin) {
          items = items.concat(
            <a
              ref={ key4 }
              className={ this.activeItemRef === key4 ? 'item matrix-options active-item' : 'item matrix-options' }
              key={ key4 }
              onClick={ ()=> { this.showEmailRecipientModal(matrix.email_recipient, matrix.name); this.setActiveItem(key4) } }>
              <span><Icon name='users'/> <span>Manager Notifications</span></span>
            </a>
          )
        }
      }
      return items
    })
  }

  setActiveItem(ref){
    if (this.activeItemRef){
      if (this.refs[this.activeItemRef]) {
        this.refs[this.activeItemRef].classList.toggle('active-item');
      }
    }
    this.activeItemRef = ref;
    if (this.refs[ref]) {
      this.refs[ref].classList.toggle('active-item');
    }

    if (['trainees', 'training modules', 'dashboards', 'tna'].includes(ref)) this.tagName=''
  }

  openMatrix(tagId, matrixName) {
    this.tagName = matrixName;

    if (this.state.showDashboard===true) {
      this.setState({ showMatrix: false })
    }

    setTimeout(()=>{
      this.setState({
        tagId: tagId,
        showMatrix: true,
        showDashboard: false,
        showCountryComparison: false,
        showTrainees: false,
        showTrainingModules: false,
        showTrainingNeedsAnalysis: false
      })
    }, 50)
  }

  openDashboard(item, matrixName) {
    this.tagName = matrixName;

    if (this.state.showDashboard===true) {
      this.setState({ showDashboard: false })
    }

    setTimeout(()=>{
      this.setState({
        tagId: item.id,
        showMatrix: false,
        showDashboard: true,
        showCountryComparison: false,
        activeItem: item,
        showTrainees: false,
        showTrainingModules: false,
        showTrainingNeedsAnalysis: false
      })
    }, 50)
  }

  openTrainees() {
    this.setActiveItem('trainees')
    this.setState({
      showMatrix: false,
      showDashboard: false,
      showCountryComparison: false,
      showTrainees: true,
      showTrainingModules: false,
      showTrainingNeedsAnalysis: false
    })
  }

  openTrainingModules() {
    this.setActiveItem('training modules')
    this.setState({
      showMatrix: false,
      showDashboard: false,
      showCountryComparison: false,
      showTrainees: false,
      showTrainingModules: true,
      showTrainingNeedsAnalysis: false
    })
  }

  openTrainingNeedsAnalysis() {
    this.setActiveItem('tna')
    this.setState({
      showMatrix: false,
      showDashboard: false,
      showCountryComparison: false,
      showTrainees: false,
      showTrainingModules: false,
      showTrainingNeedsAnalysis: true
    })
  }

  openDashboards() {
    this.setActiveItem('dashboards')
    this.setState({
      showMatrix: false,
      showDashboard: false,
      showTrainees: false,
      showCountryComparison: true,
      showTrainingModules: false,
      showTrainingNeedsAnalysis: false
    })
  }

  setTrainingMatrices(nextProps) {
    var tags = this.sortByTagName(nextProps.tags);
    var tag = nextProps.tag || {};
    this.activeItemRef = null;
    var state = {}
    var lastMatrix = {};

    for(var i = 0; i < tags.length; i++) {
      if (tags[i].id !== tag.id) {
        state[`region_${tags[i].id}`] = false;
      }
    }

    if (this.state.openAfterCreate){
      this.tagName = tag.name;
      state.tagId = tag.id;
      state.showMatrix = true;
      state[`region_${tag.id}`] = true;
      lastMatrix = tag
    }

    state.trainingMatrices = tags
    this.setState(state)

    if (this.state.openAfterCreate) {
      setTimeout(()=>{
        this.openMatrix(lastMatrix.id, lastMatrix.name);
        this.setActiveItem(lastMatrix.id + '_1')
      }, 50)
    }
  }

  sortByTagName(tags) {
    return tags.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }

  createTrainingMatrix = (details) => {
    this.setState({
      showMatrixModal: false
    })
    details.userId = this.props.user.id
    this.props.createMatrix(details)
  }

  onTitleFocus(evt){
    evt.target.setAttribute("contentEditable","true");
    this.origTitle = evt.target.innerText;
  }

  onTitleBlur(evt){
    evt.target.setAttribute("contentEditable","false");
    var newVal = evt.target.innerText.replace(/\n/g,"")
    if (newVal.trim().length === 0){
      evt.target.innerText = this.origTitle;
      this.tagName = this.origTitle;
      return
    }

    if (this.origTitle === newVal){
      return
    }

    var details = {
      old_tag_name: this.origTitle,
      tag_name: newVal,
      id: this.state.tagId,
      userId: this.props.user.id
    }
    this.props.updateMatrix(details).then(()=>{
      this.tagName = newVal;
    })
  }

  toggleMatrixModal = () => {
    this.setState({ showMatrixModal: !this.state.showMatrixModal })
  }

  toggleEmailRecipientsModal = (showEmailRecipientModal) => {
    if(showEmailRecipientModal) {
      this.currentView = 'TrainingRegister'
      this.props.getUsers()
    }
    else {
      this.currentView = ''
      this.setState({showEmailRecipientModal})
    }
  }

  showEmailRecipientModal = (emailRecipient, tag_name) => {
    emailRecipient = (emailRecipient ? {...emailRecipient} : { email_recipients: [], email_type: 'OverdueNotification', mode: 'create' })
    emailRecipient.tag_name = tag_name
    this.setState({emailRecipient})
    this.toggleEmailRecipientsModal(true)
  }

  saveEmailRecipient = (emailRecipient) => {
    if(emailRecipient.mode === 'create'){
      this.props.createEmailRecipient(emailRecipient)
    } else {
      this.props.updateEmailRecipient(emailRecipient)
    }
  }

  render() {

    const nothingShown = (!this.state.showMatrix && !this.state.showDashboard && !this.state.showTrainees && !this.state.showTrainingModules
      && !this.state.showCountryComparison && !this.state.showTrainingNeedsAnalysis)

    return (
      <div className="training-matrices">
        <SystemHeader
          showMenu={true}
          onMenuClick={this.toggleSideBar}
          showLoading={true}
          onTitleFocus={this.onTitleFocus}
          onTitleBlur={this.onTitleBlur}
          tagName={this.tagName}
        />
        <div className='training-matrices-body'>
          <div ref='menu' className='ui vertical menu show-menu'>
            { this.createMenuItems() }
          </div>
          <div ref='content' className="training-matrices-content">
            { this.state.showMatrix && <TagMatrix tagId={ this.state.tagId } tagName={this.tagName} loading={true}/> }
            { this.state.showTrainees && <Trainees loading={true}/> }
            { this.state.showDashboard && <TagDashboard activeItem={ this.state.activeItem } tagName={this.tagName}/> }
            { this.state.showCountryComparison && <CountryComparison activeItem={ this.state.activeItem }/> }
            { this.state.showTrainingModules && <V2TrainingModules loading={true} userIsAdmin={this.props.user.is_admin}/> }
            { this.state.showTrainingNeedsAnalysis && <TrainingNeedsAnalysis userIsAdmin={this.props.user.is_admin}/> }
            { 
              nothingShown &&
              <div className="welcome-message">
                <span>Create a new matrix or Open an existing matrix in the side menu.</span>
              </div>
            }
          </div>
          {
            this.state.showMatrixModal &&
            <TrainingMatrixModal
              onClose={this.toggleMatrixModal}
              onCreate={this.createTrainingMatrix}
              context='regions'
              mode='create'
              parentName='TrainingRegister'
            />
          }
          <LogoutMessage
            show={ this.state.showLogOutMessage }
            onClose={ () => this.setState({ showLogOutMessage: false}) }
          />
        </div>
        { 
          this.state.showEmailRecipientModal &&
          <EmailRecipientModal
            onClose={ () => this.toggleEmailRecipientsModal(false) }
            user={this.state.user}
            users={this.state.users}
            emailRecipient={this.state.emailRecipient}
            saveEmailRecipient={this.saveEmailRecipient}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    matrices: state.trainingMatrix.matrices,
    requestSuccess: state.trainingMatrix.requestSuccess,
    requestType: state.trainingMatrix.requestType,
    token: state.token.accessToken,
    user: state.user.user,
    users: state.user.users,
    usersRequestType: state.user.requestType,
    tags: state.tags.tags,
    tag: state.tags.tag,
    tagsRequestSuccess: state.tags.requestSuccess,
    tagsRequestType: state.tags.requestType,
    v2TrainingModules: state.v2TrainingModules,
    emailRecipients: state.emailRecipients
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createMatrix: (details) => {
      dispatch(createTag(details))
    },
    updateMatrix: (details) => {
      return dispatch(updateTag(details))
    },
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    getTags: (params) => {
      return dispatch(getTags(params))
    },
    getUsers: () => {
      return dispatch(getUsers())
    },
    createEmailRecipient: (params) => {
      return dispatch(createEmailRecipient(params))
    },
    updateEmailRecipient: (params) => {
      return dispatch(updateEmailRecipient(params))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingRegister);



// WEBPACK FOOTER //
// ./src/views/training_register.js